import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'
import store from '@/store'

const endpoint = 'letters'
const Actions = crudActions(endpoint)

const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/inbox`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const history = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  const letter = store.state.inbox.history_letter
  axios.get(`/${endpoint}/inbox`, {
    params: {
      ...queryParams,
      from_org_id: letter.from_org.id,
      to_org_id: letter.to_org.id,
      period_id: letter.period.id,
    },
  })
    .then(response => {
      commit('LIST', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const accepted = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/${id}/accepted/`)
    .then(response => {
      commit('TABLE_ONE', response.data.table1)
      commit('TABLE_TWO', response.data.table2)
      resolve(response.data)
    })
    .catch(error => {
      reject(error)
    })
})
const acceptOrReject = (ctx, data) => {
  const formData = new FormData()
  formData.append('letter_status', data.letter_status)
  if (data.reject_info) {
    formData.append('reject_info', data.reject_info)
  }
  if (data.reason_file) {
    formData.append('reason_file', data.reason_file)
  }
  return axios.patch(`/${endpoint}/${data.id}/`, formData)
}

Actions.list = list

export default {
  ...Actions,
  history,
  accepted,
  acceptOrReject,
}
